import React from 'react';
import { Card } from 'antd';
import CodeBlock from './CodeBlock';

const KernelLogs = ({ onCopy }) => {
  const kernelCommand = {
    code: 'dmesg',
    description: 'Command:',
    subDescription: 'Displays kernel ring buffer messages.\nUseful for hardware and system issues.',
  };

  return (
    <Card title="View Kernel Logs" bordered={false}>
      <CodeBlock
        code={kernelCommand.code}
        description={kernelCommand.description}
        subDescription={kernelCommand.subDescription}
        onCopy={onCopy}
      />
      <p>Use this to view necessary kernel-level logs.</p>
    </Card>
  );
};

export default KernelLogs; 